import { OPERATIONS_BACKEND_URL } from '@/config'
import { runJsonPost } from '@/backend-client'

export const submitLicensePlateInfo = async licensePlateInfo => {
  await runJsonPost(
    `${OPERATIONS_BACKEND_URL}/ordering/save_licence_plate_info`,
    licensePlateInfo
  )
}
